// Module
var code = "<th name=header data-value=arrangement.viewTypeProperties.shipmentUnitWrapperCategory translate>arrangement.viewTypeProperties.shipmentUnitWrapperCategory</th> <th name=header data-value=quantity translate>quantity</th> ";
// Exports
module.exports = code;